"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuyApi = void 0;
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable max-len */
const axios_1 = __importDefault(require("axios"));
class BuyApi {
    constructor() {
        this._url = 'https://api-kassa.delabteam.com';
        this._urlTonService = 'https://squid-app-6pq6e.ondigitalocean.app/exchange/buy-ton';
    }
    // /api/invoice
    async post(url, data) {
        try {
            const res = await axios_1.default.post(`${this._url}${url}`, data);
            return res.data;
        }
        catch (error) {
            console.error(error);
            return undefined;
        }
    }
    async getInvoiceHistory(url, data) {
        try {
            const res = await axios_1.default.get(`${this._url}${url}?${new URLSearchParams(data)}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
            return undefined;
        }
    }
    async BuyTon(data) {
        try {
            const res = await axios_1.default.post(`${this._urlTonService}`, data);
            return res.data;
        }
        catch (error) {
            console.error(error);
            return undefined;
        }
    }
}
exports.BuyApi = BuyApi;
